export const ALLOWED_DEST_PREFIXES = [
  '/etc/ssl/priv/',
  '/etc/ssl/keys/',
  '/etc/ssl/',
  '/usr/local/bin/',
];

export function isAllowedDest(dest: string): boolean {
  if (!dest || dest.includes('..') || !dest.startsWith('/')) return false;
  return ALLOWED_DEST_PREFIXES.some((p) => dest.startsWith(p) && dest.length > p.length);
}
